import {ExclamationIcon} from '@primer/octicons-react'
import {SkeletonAvatar, SkeletonText} from '@primer/react/experimental'
import {ForYouItem} from './ForYouItem'

/**
 * Skeleton placeholder rendered while a ForYouItem's async content loads.
 * Mirrors the collapsed-header shape of ForYouItem so the layout is stable.
 */
export function ForYouItemSkeleton({
  text,
  variant,
  action,
  emphasized = false,
}: {
  text?: string
  variant?: 'default' | 'embedded'
  action?: React.ReactNode
  emphasized?: boolean
}) {
  return (
    <ForYouItem
      ariaLabel="Loading item"
      itemName="Loading item"
      leadingVisual={<SkeletonAvatar size={emphasized ? 40 : 16} />}
      emphasizedLeadingVisual={emphasized}
      title={text ?? <SkeletonText size="bodyMedium" />}
      description={emphasized ? <SkeletonText size="bodySmall" /> : undefined}
      actionSlot={action}
      variant={variant}
      busy
    />
  )
}

/**
 * Error state rendered when a ForYouItem's content throws.
 * Matches the collapsed-header shape so the list layout is preserved.
 */
export function ForYouItemError() {
  return (
    <ForYouItem
      itemId="error"
      visual={{kind: 'icon', icon: ExclamationIcon, tone: 'danger', glyphSize: 12}}
      title="Unable to load this item"
      subText="Try reloading the page."
    />
  )
}
